import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VParallax,{staticClass:"home-parallax",attrs:{"height":"450","cover":"","src":require("@/assets/img/parallax.jpeg")}},[_c(VRow,[_c(VCol,{staticClass:"text-center pt-12",attrs:{"cols":"12"}},[_c('img',{staticClass:"logo-home",style:({width:_vm.getWidth}),attrs:{"src":require("@/assets/img/LogoTremendas7.png")}})]),_c(VCol,{attrs:{"cols":"12"}},[_c('home-data')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }